import request from '../../axios/axiosconfig.js'

export function getStorePosition() {
  return request({
    url: '/ps/storeStatistics/getStorePosition',
    method: 'get',
    timeout: 20000
  })
}


// WEBPACK FOOTER //
// ./src/api/devicestatics/deviceDistribution.js